"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var classNames = require("classnames");
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, text = _a.text, size = _a.size, icon = _a.icon, iconRight = _a.iconRight, color = _a.color, border = _a.border, className = _a.className, responsive = _a.responsive, block = _a.block, round = _a.round, url = _a.url, externalUrl = _a.externalUrl, rest = __rest(_a, ["children", "text", "size", "icon", "iconRight", "color", "border", "className", "responsive", "block", "round", "url", "externalUrl"]);
        var computedClassName = classNames('sok-button', size, 'sok-button-color-' + (color || 'light-gray'), border && 'sok-button-border sok-button-border-' + border, rest.disabled && 'disabled', block && 'block', round && 'round', responsive && 'responsive', className);
        if (url) {
            return (React.createElement(react_router_dom_1.Link, { className: computedClassName, style: rest.style, to: url },
                icon && React.createElement("span", { className: "sok-button-icon" }, icon),
                (text || children) && (React.createElement("span", { className: "sok-button-text" }, text || children)),
                iconRight && (React.createElement("span", { className: "sok-button-icon-right" }, iconRight))));
        }
        else if (externalUrl) {
            return (React.createElement("a", { className: computedClassName, style: rest.style, href: externalUrl },
                icon && React.createElement("span", { className: "sok-button-icon" }, icon),
                (text || children) && (React.createElement("span", { className: "sok-button-text" }, text || children)),
                iconRight && (React.createElement("span", { className: "sok-button-icon-right" }, iconRight))));
        }
        return (React.createElement("button", __assign({ className: computedClassName, type: "button" }, rest),
            icon && React.createElement("span", { className: "sok-button-icon" }, icon),
            (text || children) && (React.createElement("span", { className: "sok-button-text" }, text || children)),
            iconRight && (React.createElement("span", { className: "sok-button-icon-right" }, iconRight))));
    };
    return Button;
}(React.Component));
exports.Button = Button;
//# sourceMappingURL=index.js.map